import React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from "react-router-dom"
import { Button } from '../../components/common'
import { NotFoundIcon } from '../../theme/icons'
import ErrorBoundary from '../../components/Errorboundary'

 const Logout = React.memo(() => {
    const navigate = useNavigate()
    const intl = useIntl()
    return (<ErrorBoundary>
        <div className="flex h-screen text-center items-center justify-center mx-8">
            <div className="">
                <div className="flex justify-center"><NotFoundIcon /></div>
                <h1 className="font-semibold text-black mt-2">{intl?.messages["LOGOUT.SUCCESS.MESSAGE"]}</h1>
                <p className="my-3 text-secondary-400">{intl?.messages["LOGOUT.SUCCESS.MESSAGE.DESCRIPTION"]}</p>
                <Button variant="primary" onClick={() => navigate('/login')} text={intl.formatMessage({ id: 'LOGIN.BUTTON' })} />
            </div>
        </div></ErrorBoundary>
    )
})

export default Logout;
